export default "mutation curtailValidPeriod($curtailInfo: CurtailValidPeriodRequest) {\n  curtailValidPeriod(curtailInfo: $curtailInfo) \n}";